import React from 'react';
import s from './Page.css';

export class Page extends React.Component {
    render() {
        return <div className={s.page}>{this.props.children}</div>;
    }
}



// WEBPACK FOOTER //
// ./app/web/src/components/containers/Page.jsx